import Ad from './ad';
import { ListStatus, EditableStatus } from '@/store/types';

export enum AdsActions {
  LOAD_ALL = 'LOAD_ALL',
  LOAD_EDITABLE = 'LOAD_EDITABLE',
  CREATE = 'CREATE',
  SAVE = 'SAVE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
  APPLY_FILTERS = 'APPLY_FILTERS',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  LOAD_PRODUCTS = 'LOAD_PRODUCTS',
  LOAD_COUNTRIES = 'LOAD_COUNTRIES',
  
  /**
   * Bulk actions
   */
  BULK_DELETE = 'BULK_DELETE',
  BULK_RESTORE = 'BULK_RESTORE',
}

export enum AdsMutations {
  SET_ALL = 'SET_ALL',
  SET_ALL_STATUS = 'SET_ALL_STATUS',
  SET_EDITABLE = 'SET_EDITABLE',
  SET_EDITABLE_STATUS = 'SET_EDITABLE_STATUS',
  SET_LIST_PAGINATION = 'SET_LIST_PAGINATION',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  UPDATE_INITIAL_EDITABLE = 'UPDATE_INITIAL_EDITABLE',
  SET_PRODUCTS = 'SET_PRODUCTS',
  SET_COUNTRIES = 'SET_COUNTRIES',
}

export interface AdsState {
  list: Ad[];
  listStatus: ListStatus;
  listPagination: {
    currentPage: number;
    lastPage: number;
    total: number;
  };
  editable: Ad | null;
  initialEditable: Ad | null;
  editableStatus: EditableStatus;
  products: { id: number; title: string }[];
  countries: { id: number; title: string }[];
}

export interface AdsFilters {
  search?: string;
  status?: number;
  product?: number;
  country?: number;
  page?: number;
} 